<mat-card appearance="outlined" class="item-detail" fxFlex="100" fxFlexFill
  [ngClass]="{ 'not-collapse': flow_order.type == 'antifraud'|| flow_order.type == 'checkenrollment'  }">
  <mat-card-content>
    <mat-expansion-panel hideToggle [expanded]="expandedStepState">
      <mat-expansion-panel-header (keydown.Space)="$event.stopImmediatePropagation()">
        <mat-panel-title fxLayoutAlign="start center">
          <mat-icon *ngIf="!onlyViewer && !flow_order.disabled" class="drag-item" fxShow fxHide.lt-md="true">
            drag_indicator
          </mat-icon>

          <div fxFlex="100" fxLayoutAlign="start center" (click)="$event.stopImmediatePropagation()">
            <span class="title c-text" #flow_order_name>{{
              flow_order.name
              ? flow_order.name
              : ("flows.detail.custom_action_title" | translate)
              }}</span>

            <span *ngIf="flow_order_name.hidden" class="title edit">
              <mat-form-field>
                <input matInput autoSizeInput [hidden]="!flow_order_name.hidden" [(ngModel)]="flow_order.name"
                  #editInput (keydown.Space)="$event.stopImmediatePropagation()"
                  (keyup.enter)="inputNameKeyupEnter($event)" minlength="3" maxlength="50" name="flow_order.key" />
              </mat-form-field>
            </span>

            <button *ngIf="flow_order_name.hidden" class="btn-edit"
              (click)="editStep($event); flow_order_name.hidden = false" mat-icon-button fxShow fxHide.lt-md="true">
              <mat-icon class="icon-edit" svgIcon="icon_check"></mat-icon>
            </button>

            <button class="btn-edit" mat-icon-button fxShow fxHide.lt-md="true"
              (click)="flow_order_name.hidden = true; clickEditName()" *ngIf="
                !flow_order_name.hidden &&
                !onlyViewer &&
                !(flow_order.type == 'antifraud') &&  !(flow_order.type == 'checkenrollment') &&
                !flow_order.disabled
              ">
              <mat-icon class="icon-edit" svgIcon="icon_edit"></mat-icon>
            </button>
          </div>
        </mat-panel-title>
        <button *ngIf="!onlyViewer && !flow_order.disabled && !isContainsServiceTuna" class="btn-delete"
          (click)="remove($event, flow_order.key)" mat-icon-button fxShow fxHide.lt-md="true">
          <mat-icon class="icon-delete">delete_outline</mat-icon>
        </button>
        <button class="btn-expand" mat-icon-button fxShow fxHide.lt-md="true" *ngIf="
            flow_order.actions.length > 0 && flow_order.type != 'antifraud'  && flow_order.type != 'checkenrollment'
          ">
          <mat-icon class="icon-expand">keyboard_arrow_down</mat-icon>
        </button>
        <!-- <app-action-menu class="mobile-detail" [classIcon]="'action-icon'" fxHide fxShow.lt-md="true">
          <div class="sheet-container-flow-detail">
            <div class="sheet-header" fxLayoutAlign="start center" fxLayoutGap="10px">
              <div class="icon" fxFlex="40px" fxFlex.xs="30px" fxLayoutAlign="center center">
                <mat-icon *ngIf="model.flow_order.type == 'RiskAnalytics'" inline="true">security</mat-icon>
                <mat-icon *ngIf="4order.type == 'Action'" inline="true">directions_run</mat-icon>
                <mat-icon *ngIf="model.flow_order.type == 'ManualAnalysis'" inline="true">verified_user</mat-icon>
                <mat-icon *ngIf="model.flow_order.type == 'Authorize'" inline="true">payment</mat-icon>
              </div>
              <div class="sheet-title">{{model.flow_order.name}}</div>
            </div>
            <div class="sheet-container">
              <div class="rules-set" *ngFor="let action of model.flow_order.actions">
                <div class="label">{{ 'flows.detail.action.verification' | translate}}</div>
                <div class="rule">
                  <div class="value primary">{{ action.variable_selected?.name}}</div>
                  <div class="operator">{{action.operator_selected}}</div>
                  <div class="value">{{action.value_selected}}</div>
                  <div class="action" fxLayout="row">
                    <div class="operator">{{ 'flows.detail.action.then' | translate}}</div>
                    <div fxLayout="row" fxLayoutAlign="start center">
                      <div class="value">{{action.action_selected.description}}</div>
                      <div class="status-action success"></div>
                    </div>
                  </div>
                  <div class="operator floating">{{ 'flows.detail.and' | translate}}</div>
                </div>
              </div>
            </div>
          </div>
        </app-action-menu> -->
      </mat-expansion-panel-header>
      <div class="detail" fxShow fxHide.lt-md="true" fxLayout="column" (mousedown)="$event.stopPropagation()" *ngIf="
          flow_order.actions.length > 0 &&
          flow_order.type != 'antifraud' &&
          flow_order.type != 'checkenrollment' &&
          flow_order.type != 'riskanalytics'
        ">
        <div class="rules-set" *ngFor="
            let action of flow_order.actions;
            let i = index;
            let last = last;
            let first = first
          " fxLayout="row" fxFlex="100">
          <div fxFlex="75" fxFlex.lt-lg="70" fxLayout="column">
            <div class="label" *ngIf="first">
              {{ "flows.detail.action.verification" | translate }}
            </div>
            <div class="rules-container" fxFlex="100" *ngFor="
                let expression of action.filters?.expression?.nary_expr
                  ?.expression_list;
                let i = index;
                let last2 = last;
                let first2 = first
              ">
              <div class="rule" fxLayout="row">
                <div fxFlex="100" fxLayoutAlign="start center" fxLayoutGap="10px">
                  <div fxFlex="100" fxLayout="column">
                    <div fxFlex="100">
                      <div class="rules-set" fxLayoutGap="10px" fxFlex="100">
                        <div class="step" fxFlex>
                          <mat-form-field hideRequiredMarker="true" floatLabel="never">
                            <input type="text" placeholder="{{
                                'flows.detail.fields.options' | translate
                              }}" matInput [matAutocomplete]="option" (blur)="blurEventOption($event, expression)"
                              [formControl]="
                                form.get('options' + expression.binary_expr.id)
                              " (ngModelChange)="
                                valuechangeOption(
                                  expression,
                                  form.get(
                                    'options' + expression.binary_expr.id
                                  ).value,
                                  $event
                                )
                              " />
                            <mat-autocomplete autoActiveFirstOption #option="matAutocomplete" (optionActivated)="
                                selectedOption(
                                  expression,
                                  $event.option.value,
                                  action
                                )
                              " (optionSelected)="
                                selectedOption(
                                  expression,
                                  $event.option.value,
                                  action
                                )
                              ">
                              <mat-option *ngFor="
                                  let option of expression.binary_expr
                                    .variables_filtered
                                " [value]="option.name">
                                {{ option.name }}
                              </mat-option>
                            </mat-autocomplete>
                            <mat-error *ngIf="
                                form
                                  .get('options' + expression.binary_expr.id)
                                  .hasError('options')
                              ">
                              {{ "flows.detail.fields.validation" | translate }}
                              <strong>'{{
                                form.get(
                                "options" + expression.binary_expr.id
                                ).errors.options.value
                                }}'</strong>
                              {{ "flows.detail.fields.alow" | translate }}
                            </mat-error>
                            <mat-error *ngIf="
                                form.get('options' + expression.binary_expr.id)
                                  .errors?.required
                              ">
                              {{ "flows.detail.fields.required" | translate }}
                            </mat-error>
                          </mat-form-field>
                        </div>
                        <div class="step" fxFlex>
                          <mat-form-field hideRequiredMarker="true" floatLabel="never">
                            <input type="text" placeholder="{{
                                'flows.detail.fields.operators' | translate
                              }}" matInput [matAutocomplete]="operator" (blur)="
                                blurEventOperatorsAction($event, expression)
                              " [formControl]="
                                form.get(
                                  'operators' + expression.binary_expr.id
                                )
                              " (ngModelChange)="
                                valuechangeOperators(
                                  expression,
                                  form.get(
                                    'operators' + expression.binary_expr.id
                                  ).value,
                                  $event
                                )
                              " />
                            <mat-autocomplete autoActiveFirstOption #operator="matAutocomplete">
                              <mat-option *ngFor="
                                  let operator of expression.binary_expr
                                    .operators_filtered
                                " [value]="operator">
                                {{ operator }}
                              </mat-option>
                            </mat-autocomplete>
                            <mat-error *ngIf="
                                form
                                  .get('operators' + expression.binary_expr.id)
                                  .hasError('operators')
                              ">
                              {{ "flows.detail.fields.validation" | translate }}
                              <strong>'{{
                                form.get(
                                "operators" + expression.binary_expr.id
                                ).errors.operators.value
                                }}'</strong>
                              {{ "flows.detail.fields.alow" | translate }}
                            </mat-error>
                            <mat-error *ngIf="
                                form.get(
                                  'operators' + expression.binary_expr.id
                                ).errors?.required
                              ">
                              {{ "flows.detail.fields.required" | translate }}
                            </mat-error>
                          </mat-form-field>
                        </div>
                        <div class="step" fxFlex>
                          <mat-form-field hideRequiredMarker="true" floatLabel="never"
                            *ngIf="expression.binary_expr.values?.length != 0">
                            <input type="text" placeholder="{{
                                'flows.detail.fields.value' | translate
                              }}" matInput [matAutocomplete]="value" (blur)="blurEventValues($event, expression)"
                              [formControl]="
                                form.get('values' + expression.binary_expr.id)
                              " (ngModelChange)="
                                valuechangeValues(
                                  expression,
                                  form.get('values' + expression.binary_expr.id)
                                    .value,
                                  $event
                                )
                              " />
                            <mat-autocomplete autoActiveFirstOption #value="matAutocomplete">
                              <mat-option *ngFor="
                                  let value of expression.binary_expr
                                    .values_filtered
                                " [value]="value">
                                {{ value }}
                              </mat-option>
                            </mat-autocomplete>
                            <mat-error *ngIf="
                                form
                                  .get('values' + expression.binary_expr.id)
                                  .hasError('values')
                              ">
                              {{ "flows.detail.fields.validation" | translate }}
                              <strong>'{{
                                form.get("values" + expression.binary_expr.id)
                                .errors.values.value
                                }}'</strong>
                              {{ "flows.detail.fields.alow" | translate }}
                            </mat-error>
                            <mat-error *ngIf="
                                form.get('values' + expression.binary_expr.id)
                                  .errors?.required
                              ">
                              {{ "flows.detail.fields.required" | translate }}
                            </mat-error>
                          </mat-form-field>
                          <mat-form-field hideRequiredMarker="true" floatLabel="never"
                            *ngIf="expression.binary_expr.values?.length == 0">
                            <input type="text" placeholder="{{
                                'flows.detail.fields.value' | translate
                              }}" matInput [formControl]="
                                form.get('values' + expression.binary_expr.id)
                              " (blur)="blurEventValues($event, expression)" />
                          </mat-form-field>
                        </div>
                        <div class="step" fxLayoutAlign="start center" fxLayoutGap="8px" fxFlex="30px">
                          <div *ngIf="last2 && !onlyViewer && !flow_order.disabled"
                            class="action ic-svg-green c-pointer" fxLayoutAlign="center center"
                            (click)="createNewExpression(action)">
                            <mat-icon class="icon-add">add_circle_outline
                            </mat-icon>
                          </div>
                          <div *ngIf="
                              action.filters?.expression?.nary_expr
                                ?.expression_list.length > 1 &&
                              !onlyViewer &&
                              !flow_order.disabled
                            " class="action remove ic-svg-9 c-pointer" fxLayoutAlign="center center"
                            (click)="removeExpression(action, expression)">
                            <mat-icon class="icon-add">delete_outline
                            </mat-icon>
                          </div>
                        </div>
                      </div>
                      <div class="step gap" [ngClass]="{
                          'step-list':
                            action.filters?.expression?.nary_expr
                              ?.expression_list.length > 1
                        }" fxFlex="60px" fxLayoutAlign="end center">
                        <div *ngIf="first2" class="icon-operator mr-3" fxFlex="24px" fxLayoutAlign="center center">
                          <mat-icon class="icon-arrowshape-right ic-svg-6" svgIcon="icon_arrowshape-right"></mat-icon>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="rule" fxFlex="25" fxFlex.lt-lg="30" fxLayout="column">
            <div class="label" *ngIf="first">
              {{ "flows.detail.action.then" | translate }}
            </div>
            <div class="rules-set" fxFlex="100" fxLayout="row" fxLayoutGap="10px">
              <div class="step" fxFlex="100">
                <mat-form-field class="status" hideRequiredMarker="true" floatLabel="never">
                  <input type="text" placeholder="{{ 'flows.detail.action.then' | translate }}" matInput
                    [matAutocomplete]="actionAuto" [formControl]="form.get('actions' + action.id)" (ngModelChange)="
                      valuechangeAction(
                        action,
                        form.get('actions' + action.id).value
                      )
                    " />
                  <div class="status-action" [ngClass]="{
                      success:
                        action.action.type.toLowerCase() == 'capture' ||
                        action.action.type.toLowerCase() == 'approve' ||
                        action.action.type.toLowerCase() == 'authorize' ||
                        action.action.type.toLowerCase() == 'gotoauthorize',
                      alert:
                        action.action.type.toLowerCase() == 'waitantifraud' ||
                        action.action.type.toLowerCase() == 'waitgateway' ||
                        action.action.type.toLowerCase() == 'waitoncapture' ||
                        action.action.type.toLowerCase() == 'pendingmanualanalysis' ||
                        action.action.type.toLowerCase() == 'waitanyantifraud' ||
                        action.action.type.toLowerCase() == 'waitanyapprovedantifraud' ||
                        action.action.type.toLowerCase() == 'gotoaccumulatereturningcapture' ||
                        action.action.type.toLowerCase() == 'accumulatereturningcapture',
                      error:
                        action.action.type.toLowerCase() == 'cancel' ||
                        action.action.type.toLowerCase() == 'reject' ||
                        action.action.type.toLowerCase() == 'denied',
                      inactive:
                        action.action.type.toLowerCase() == 'challengeresult' ||
                        action.action.type.toLowerCase() == 'checkenrollment' ||
                        action.action.type.toLowerCase() == 'waitoncapture' ||
                        action.action.type.toLowerCase() == 'waitgateway'
                    }"></div>
                  <mat-autocomplete autoActiveFirstOption #actionAuto="matAutocomplete"
                    (optionSelected)="selectAction(action, $event.option.value)">
                    <mat-option *ngFor="let action of action.action.actions_filtered" [value]="action.id">
                      {{ action.description }}
                    </mat-option>
                  </mat-autocomplete>
                  <mat-error *ngIf="form.get('actions' + action.id).hasError('actions')">
                    {{ "flows.detail.fields.validation" | translate }}
                    <strong>'{{
                      form.get("actions" + action.id).errors.actions.value
                      }}'</strong>
                    {{ "flows.detail.fields.alow" | translate }}
                  </mat-error>
                  <mat-error *ngIf="form.get('actions' + action.id).errors?.required">
                    {{ "flows.detail.fields.required" | translate }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div fxFlex="60px" fxLayoutGap="6px" style="height: 58px">
                <div *ngIf="last && !onlyViewer && !flow_order.disabled" fxFlex="auto"
                  class="action ic-svg-green c-pointer" fxLayoutAlign="start center" (click)="createNewFlowOrder()">
                  <mat-icon class="icon-add">add_circle_outline </mat-icon>
                </div>
                <div *ngIf="
                    flow_order.actions.length > 1 &&
                    !onlyViewer &&
                    !flow_order.disabled &&
                    !isContainsServiceTuna
                  " fxFlex="auto" class="action remove ic-svg-9 c-pointer" fxLayoutAlign="start center"
                  (click)="removeFlowOrder(action.id)">
                  <mat-icon class="icon-add">delete_outline </mat-icon>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </mat-expansion-panel>
  </mat-card-content>
</mat-card>
